import { Button, Form } from 'antd';
import './index.less';
import React from 'react';
import { func, any, object } from 'prop-types';

/**
 * @param {object} form antd 的 form 对象
 * @param {ReactNode} children 以 Form.Item 组成的自定义查询项
 * @param {function} onSubmit 表单提交触发的事件， void onSubmit(values)
 */

const tailFormItemLayout = {
  wrapperCol: {
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const formItemLayout = {
  labelCol: {
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    sm: {
      span: 16,
    },
  },
};

export default function SearchForm(props) {
  const {
    form, children, onSubmit, initialValues,
  } = props;
  const { resetFields, submit } = form;
  const handleReset = () => {
    resetFields();
    submit();
  };

  return (
    <Form className="search-form" {...formItemLayout} onFinish={onSubmit} form={form} initialValues={initialValues}>
      <div className="form-item">{children}</div>
      <div className="form-item">
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            查询
          </Button>
          <Button onClick={handleReset} ghost type="primary">
            重置
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
}
SearchForm.propTypes = {
  children: React.ReactNode,
  onSubmit: func,
  form: any,
  initialValues: object,
};
